import { Card } from "reactstrap";
import { Alert, Button, CardContent, FormControl, Grid, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { ScivalAutorDTO } from "../../interfaces/IResearch/InvestigadorScopusDTO";
import { Unidad } from "../../interfaces/Unidad";
import { useEffect, useState } from "react";
import CatalogService from "../../services/CatalogService";

const catalogService = new CatalogService();

interface Props {
  usuario: ScivalAutorDTO,
  token: any,
  onResponse?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
}

export const IResearchForm: React.FC<Props> = ({ usuario, token, onResponse }) => {
  const [unidades, setUnidades] = useState<Array<Unidad>>([])

  const GetUnidad = async () => {
    try {
      const data = await catalogService.obtenerCatalogoUnidades();
      setUnidades(data.objDatos);
    } catch (error) {
      console.error(error);
    }
  };  
  
  useEffect(() => {
    GetUnidad();
  }, [])

  return (
    <Card sx={{ maxWidth: 300, borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Formik
          initialValues={usuario}
          onSubmit={(values, { setSubmitting }) => {
            console.log(values);
          }}
        >
          {({ values, setFieldValue, errors, touched, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    fullWidth
                    id="nombreCompleto"
                    name="nombreCompleto"
                    label="Investigador"
                    disabled
                    error={touched.nombreCompleto && Boolean(errors.nombreCompleto)}
                  />
                  <ErrorMessage name="nombreCompleto" className='errorMessage' component="div">
                    {(error) => (
                      <Alert severity="error">
                        {error}
                      </Alert>
                    )}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    fullWidth
                    id="scopusNombreAutor"
                    name="scopusNombreAutor"
                    label="Scopus Name"
                    disabled
                    error={touched.scopusNombreAutor && Boolean(errors.scopusNombreAutor)}
                  />
                  <ErrorMessage name="scopusNombreAutor" className='errorMessage' component="div">
                    {(error) => (
                      <Alert severity="error">
                        {error}
                      </Alert>
                    )}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12} lg={8}>
                  <Field
                    as={TextField}
                    fullWidth
                    id="scopusId"
                    name="scopusId"
                    label="ScopusId"
                    error={touched.scopusId && Boolean(errors.scopusId)}
                  />
                  <ErrorMessage name="scopusId" className='errorMessage' component="div">
                    {(error) => (
                      <Alert severity="error">
                        {error}
                      </Alert>
                    )}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12} lg={4} style={{ display: "flex", justifyContent: "center" }}>
                  <Button variant="contained" style={{ backgroundColor: '#517ED3', color: 'white' }} >
                    Consultar
                  </Button>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    id="orcId"
                    name="orcId"
                    label="ORCID"
                    error={touched.orcId && Boolean(errors.orcId)}
                  />
                  <ErrorMessage name="orcId" className='errorMessage' component="div">
                    {(error) => (
                      <Alert severity="error">
                        {error}
                      </Alert>
                    )}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    id="hIndex"
                    name="hIndex"
                    label="H-index"
                    error={touched.hIndex && Boolean(errors.hIndex)}
                  />
                  <ErrorMessage name="hIndex" className='errorMessage' component="div">
                    {(error) => (
                      <Alert severity="error">
                        {error}
                      </Alert>
                    )}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Unidad</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {values.unidades.map((unidad, index) => (
                        <TableRow key={'uni-' + index}>
                          <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                          <TableCell>
                            <FormControl >
                              <Select
                                name={`unidades[${index}].idUnidad`}
                                value={unidad.idUnidad}
                              >
                                {/* Agrega más roles según sea necesario */}
                                <MenuItem key={"null-unidad-col"} value="0">Ninguna</MenuItem>
                                {unidades.map((rol) => (
                                  <MenuItem key={rol.idunidad} value={rol.idunidad}>
                                    {rol.codacad}
                                  </MenuItem>
                                ))}
                              </Select>
                              <ErrorMessage name={`unidades[${index}].idUnidad`} className='errorMessage' component="div">
                                {(error) => (
                                  <Alert severity="error">
                                    {error}
                                  </Alert>
                                )}
                              </ErrorMessage>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <FormControl >
                              <Select
                                name={`unidades[${index}].estado`}
                                value={unidad.estado}
                              >
                                {/* Agrega más roles según sea necesario */}
                                <MenuItem key={"active"} value="A">Activo</MenuItem>
                                <MenuItem key={"inactive"} value="I">Inactivo</MenuItem>                                
                              </Select>
                              <ErrorMessage name={`unidades[${index}].estado`} className='errorMessage' component="div">
                                {(error) => (
                                  <Alert severity="error">
                                    {error}
                                  </Alert>
                                )}
                              </ErrorMessage>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <>BOTONES</>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
                {/* Botón Guardar */}
                <Grid item xs={12}>
                  <Button variant="contained" type="submit" style={{ backgroundColor: '#517ED3', color: 'white' }} >
                    GUARDAR
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </CardContent>
    </Card>
  )
}